import { ArrowLeft } from '@/components/icons'
import { cn } from '@/lib/utils'

interface DesktopDetailHeaderProps {
  title: string
  onBack: () => void
  /** Right-aligned action slot, e.g. a kebab menu. */
  action?: React.ReactNode
  /** Breadcrumb line under the title row, e.g. `Operations / Trips / {name}`. */
  breadcrumb?: React.ReactNode
  className?: string
}

/**
 * Secondary header for desktop detail/sub-pages — a circular back button
 * inline with the record title, an optional right-aligned action, and an
 * optional breadcrumb underneath. Sits below `DesktopPageHeader`.
 */
export function DesktopDetailHeader({
  title,
  onBack,
  action,
  breadcrumb,
  className,
}: DesktopDetailHeaderProps) {
  return (
    <header className={cn('flex flex-col gap-4', className)}>
      <div className="flex items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-3">
          <button
            type="button"
            onClick={onBack}
            className="flex size-8 shrink-0 items-center justify-center rounded-full bg-content-primary-inverse hover:bg-content-primary-inverse/30"
            aria-label="Back"
          >
            <ArrowLeft className="size-5 text-content-primary-bold" />
          </button>
          <h1 className="truncate text-[30px] font-semibold leading-none tracking-[-0.3px] text-content-primary-bold">
            {title}
          </h1>
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      {breadcrumb && (
        <div className="text-sm font-medium text-content-brand-bold">
          {breadcrumb}
        </div>
      )}
    </header>
  )
}
